import { useState, useCallback } from 'react';
import { InterviewMode, CreateInterviewResponse } from '@recruitai/shared';
import { apiClient } from '../lib/api-client';

export function useCreateInterview() {
  const [isCreating, setIsCreating] = useState(false);

  const createInterview = useCallback(
    async (jobId: string, candidateId: string, mode: InterviewMode): Promise<CreateInterviewResponse> => {
      setIsCreating(true);
      try {
        return await apiClient.post<CreateInterviewResponse>(
          `/jobs/${jobId}/candidates/${candidateId}/interviews`,
          { mode }
        );
      } finally {
        setIsCreating(false);
      }
    },
    []
  );

  return { createInterview, isCreating };
}
